export const APP_BAR_HEIGHT = 64;
export const DRAWER_WIDTH = 240;
export const ACCOUNTS_TOOLBAR_TOP = 70;
export const ACCOUNTS_TOOLBAR_HEIGHT = 90;
export const MAIN_CONTENT_TOP = 150;
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100, 200, 500, 1000];
export const SMALL_ITEMS_PER_PAGE = 10;
export const LARGE_ITEMS_PER_PAGE = 200;
export const BACKEND_DATE_FORMAT = "YYYY/MM/DD";
export const BASENAME = "/sco";
export const APPNAME = "SAND eCRM";
export const TOMCAT_DEV_PORT = "8080";
export const TOMCAT_DEV_PORT_BNK = "8070";
export const BUILD_NUMBER = "v5.0.4.0";
